module.exports = __webpack_public_path__ + "028.41dc4458.png";